import { Link } from 'react-router-dom';

const popularCategories = [
  { label: 'Shoes', to: 'https://kaspreadsheet.com/category-911-Shoes.html' },
  { label: 'Clothing', to: 'https://kaspreadsheet.com/search-913/name/Shoes.html' },
  { label: 'Hoodies', to: 'https://kaspreadsheet.com/search-912/name/Shoes.html' },
  { label: 'Jackets', to: 'https://kaspreadsheet.com/search-914/name/Shoes.html' },
  { label: 'Sneakers', to: 'https://kaspreadsheet.com/category-911-Shoes.html' },
  { label: 'Luxury', to: 'https://kaspreadsheet.com/search-920/name/Shoes.html' },
  { label: 'Budget', to: 'https://kaspreadsheet.com/search-924/name/Shoes.html' },
];

export default function ContentSection() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="max-w-4xl mx-auto">
          <div className="mb-12">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-5">
              The Complete CSSBuy Spreadsheet Resource
            </h2>

            <div className="relative w-full h-[280px] md:h-[360px] rounded-lg overflow-hidden mb-8">
              <img
                src="https://readdy.ai/api/search-image?query=Flat%20lay%20photography%20of%20fashion%20shopping%20essentials%20including%20a%20tablet%20displaying%20product%20catalog%20sneakers%20watch%20and%20sunglasses%20neatly%20arranged%20on%20a%20warm%20cream%20textured%20surface%20soft%20natural%20daylight%20from%20window%20clean%20editorial%20lifestyle%20composition%20modern%20shopping%20aesthetic%20neutral%20beige%20tones&width=900&height=450&seq=content-1-v2-2026&orientation=landscape"
                alt="CSSBuy Spreadsheet product discovery and shopping resource"
                title="CSSBuy Spreadsheet Shopping Resource"
                className="w-full h-full object-cover object-top rounded-lg"
                loading="lazy"
              />
            </div>

            <div className="space-y-4 text-foreground-600 text-sm md:text-base leading-relaxed">
              <p>
                Welcome to the most comprehensive <strong className="text-foreground-900">CSSBuy Spreadsheet</strong> resource on the web. Whether you are a seasoned spreadsheet shopper or just discovering this powerful way to find products, our platform brings together everything you need in one beautifully organized directory. The <strong className="text-foreground-900">CSSBuy Spreadsheet</strong> ecosystem has grown into one of the largest product discovery networks, connecting international buyers with thousands of sellers across every imaginable category.
              </p>
              <p>
                What makes a <strong className="text-foreground-900">CSSBuy Spreadsheet</strong> so valuable? Unlike traditional online stores, spreadsheets give you direct access to seller inventories with transparent pricing, size availability, and community-verified quality ratings. Each spreadsheet is a living document — updated frequently with new arrivals, seasonal collections, and limited releases that often sell out quickly. Our directory tracks the most active and reliable spreadsheets so you never miss a drop.
              </p>
              <p>
                The <strong className="text-foreground-900">CSSBuy Spreadsheet</strong> community has developed its own culture of sharing finds, reviewing sellers, and helping newcomers navigate the process. From detailed QC photo guides to shipping cost calculators, the collective knowledge around spreadsheets has made international shopping more accessible than ever. Our mission is to organize this knowledge and make it easy to discover, compare, and act on the best spreadsheet finds available.
              </p>
            </div>
          </div>

          <div className="mb-12">
            <h3 className="font-heading text-xl font-bold text-foreground-950 mb-4">
              Popular Categories on CSSBuy Spreadsheets
            </h3>
            <div className="flex flex-wrap gap-2">
              {popularCategories.map((cat) => (
                <a
                  key={cat.label}
                  href={cat.to}
                  target="_blank"
                  rel="noopener nofollow"
                  className="px-4 py-2 bg-background-100 border border-background-200 rounded-full text-sm text-foreground-600 hover:bg-primary-50 hover:text-primary-600 hover:border-primary-200 transition-colors whitespace-nowrap"
                >
                  {cat.label}
                </a>
              ))}
            </div>
          </div>

          <div className="relative w-full h-[240px] md:h-[300px] rounded-lg overflow-hidden mb-8">
            <img
              src="https://readdy.ai/api/search-image?query=Product%20photography%20of%20a%20curated%20collection%20of%20folded%20designer%20clothing%20items%20in%20neutral%20beige%20cream%20and%20sand%20tones%20stacked%20neatly%20on%20a%20warm%20wooden%20surface%20soft%20natural%20daylight%20from%20the%20left%20clean%20minimalist%20editorial%20style%20textile%20textures%20visible%20luxury%20fashion%20aesthetic%20professional%20lighting&width=900&height=450&seq=content-2-v2-2026&orientation=landscape"
              alt="CSSBuy Spreadsheet clothing and fashion collections"
              title="CSSBuy Spreadsheet Fashion Collections"
              className="w-full h-full object-cover object-top rounded-lg"
              loading="lazy"
            />
          </div>

          <div className="bg-background-100 rounded-lg p-6 md:p-8 border border-background-200">
            <h3 className="font-heading text-lg font-bold text-foreground-950 mb-3">
              New to CSSBuy Spreadsheets? Start Here
            </h3>
            <p className="text-sm text-foreground-500 leading-relaxed mb-5">
              Our detailed beginner guide walks you through every step — from understanding how spreadsheets work to placing your first order with confidence. Learn about seller ratings, QC photo requests, shipping options, and money-saving tips from experienced spreadsheet shoppers.
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <Link
                to="/article/cssbuy-spreadsheet-guide"
                className="inline-flex px-5 py-2.5 bg-primary-500 text-white text-sm font-semibold rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                Read Full Guide
              </Link>
              <Link
                to="/guide/shopping"
                className="inline-flex px-5 py-2.5 bg-background-50 text-primary-600 text-sm font-semibold rounded-lg border border-primary-200 hover:bg-primary-50 transition-colors whitespace-nowrap"
              >
                Shopping Guide
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}